module.exports = __webpack_public_path__ + "static/media/17.e9171387.jpg";